import React from 'react';
import styles from './styles.module.scss';

type WrapperProps = {
    children?: React.ReactNode
    style?: React.CSSProperties
}

const Wrapper = ({ children, style }: WrapperProps) => {
  return (
    <div className={styles.wrapper} style={style}>
      {children}
    </div>
  );
};

export default Wrapper;
